import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import moment from 'moment';
import CloseIcon from '../../../../../commonComponents/icons/icon/CloseIcon';
import translate from '../../../../../commonComponents/translate';
import ServerSideList from '../../../../../commonComponents/lists/ServerSideList';
import { newFormatPrice } from '../../../../../services/utilityFunctions';
import Modal from '../../../../../commonComponents/modal/Modal';

function MonthlyDetailsModal(props) {
  const { t, onClose, filters } = props;

  const tableUrL = '/table/tailor-made/arcova/reports/list';
  const tableId = 'arcova_monthly_reports';

  const columns = [
    {
      field: 'weekStartDate',
      textAlign: 'left',
      title: t('report.arcova.weekStartDate'),
      width: 250,
      sortable: false,
      template: ({ weekStartDate, weekEndDate }) =>
        renderToStaticMarkup(
          <>
            {moment(weekStartDate).format('DD MMM YYYY')} -
            {moment(weekEndDate).format('DD MMM YYYY')}
          </>,
        ),
    },
    {
      field: 'VALeft',
      textAlign: 'center',
      title: t('report.arcova.modalVALeft'),
      width: 100,
      sortable: false,
      template: ({ VALeft }) =>
        renderToStaticMarkup(<div className="name">{VALeft || ' - '}</div>),
    },
    {
      field: 'VARight',
      textAlign: 'center',
      title: t('report.arcova.modalVARight'),
      width: 100,
      sortable: false,
      template: ({ VARight }) =>
        renderToStaticMarkup(<div className="name">{VARight || ' - '}</div>),
    },
    {
      field: 'groupVA',
      textAlign: 'center',
      title: t('report.arcova.modalGroupVA'),
      width: 100,
      sortable: false,
      template: ({ groupVA }) =>
        renderToStaticMarkup(<div className="name">{groupVA || ' - '}</div>),
    },
    {
      field: 'commissions',
      textAlign: 'center',
      title: t('report.arcova.modalCommissions'),
      width: 100,
      sortable: false,
      template: ({ commissions, currencyInfo }) =>
        renderToStaticMarkup(
          <div className="commissions">
            {newFormatPrice(commissions, true, currencyInfo.code) || ' - '}
          </div>,
        ),
    },
    {
      field: 'remainingVA',
      textAlign: 'center',
      title: t('report.arcova.modalRemainingVA'),
      width: 100,
      sortable: false,
      template: ({ remainingVA }) =>
        renderToStaticMarkup(
          <div className="remainingVA">{remainingVA || ' - '}</div>,
        ),
    },
  ];

  return (
    <Modal onClose={onClose} id="arcovaMonthlyDetailsModal">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modalTitle">
            <h5 className="title">{t('report.arcova.modalMonthlyDetails')}</h5>
            <button type="button" onClick={onClose} className="closeIcon">
              <CloseIcon width="20" height="20" color="#6F6C80" />
            </button>
          </div>
          <div
            id="modalBodyMonthlyDetails"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <ServerSideList
              dataSourceURL={tableUrL}
              columns={columns}
              query={filters}
              id={tableId}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

MonthlyDetailsModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};
export default translate(MonthlyDetailsModal);
